export const DEFAULT_ACTION_DIALOGS = {
  invoices: [],
  isBulk: false,
  isOpen: {
    reject: false,
    approveWithInactiveProduct: false,
    approve: false,
    cancel: false,
    writeOff: false,
    export: false
  }
}
